const USER_ID_STORAGE_KEY = 'authenticatedUserId';

/**
 * Stores the authenticated owner independently from the access-token format.
 *
 * The local database needs this stable namespace before it can read a local
 * snapshot. The auth layer calls it a user id; the sync boundary maps it to
 * its owner id without coupling this module to IndexedDB terminology.
 */
const authSessionIdentity = {
  getStoredUserId() {
    return localStorage.getItem(USER_ID_STORAGE_KEY);
  },

  setUserId(userId) {
    if (typeof userId !== 'string' || userId.length === 0) {
      throw new TypeError('userId must be a non-empty string');
    }

    localStorage.setItem(USER_ID_STORAGE_KEY, userId);
  },

  clear() {
    localStorage.removeItem(USER_ID_STORAGE_KEY);
  }
};

export default authSessionIdentity;
